// ============================================================
// 品牌常量（唯一真相源）
//   - 内容工厂（MarketingStudioWorkspace）生产时选择品牌
//   - 营销中心（MarketingWorkspace 数据看板）按同一份品牌展示
//   - 新增品牌只需在此加一条，两边自动同步
// ============================================================

export interface BrandOption {
  id: string;
  name: string;
  desc: string;
  /** 展示色（用于标签/图表） */
  color: string;
  /** 是否对外公开（量化类不上公开平台） */
  public: boolean;
}

export const BRAND_OPTIONS: BrandOption[] = [
  { id: "xeaos", name: "XEAOS", desc: "企业操作系统主品牌", color: "#38BDF8", public: true },
  { id: "hotelmind", name: "HotelMind", desc: "酒店SaaS", color: "#F59E0B", public: true },
  { id: "gold_factory", name: "Gold Factory", desc: "量化交易（黄金外汇）", color: "#F87171", public: false },
  { id: "xuanji", name: "玄机", desc: "国学命理", color: "#A78BFA", public: true },
];

export const DEFAULT_BRAND_ID = "xeaos";

export function getBrandById(id?: string): BrandOption {
  return BRAND_OPTIONS.find((b) => b.id === id) ?? BRAND_OPTIONS[0];
}
